import { createSignal, onCleanup, onMount } from "solid-js";

/**
 * True when viewport is below md breakpoint (48rem).
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = createSignal(false);

  onMount(() => {
    const media = window.matchMedia("(max-width: 47.9975rem)");
    const update = () => setIsMobile(media.matches);
    update();
    media.addEventListener("change", update);
    onCleanup(() => media.removeEventListener("change", update));
  });

  return isMobile;
}
